import React, { useEffect, useState } from 'react'
import {
  CButton,
  CForm,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from '@coreui/react-pro'
import { useStore } from 'effector-react'
import {
  $achievementsStrategy,
  $strategy,
  achievementsStrategyMounted,
  submitAchievementStrategy,
} from '../../details/model'

type Props = {
  isOpen?: boolean
  onCancel: () => void
}
export const AddAchievementModal: React.FC<Props> = ({ isOpen, onCancel }) => {
  const [achievement, setAchievement] = useState(0)

  const achievementsStrategy = useStore($achievementsStrategy)
  const strategy = useStore($strategy)

  useEffect(() => {
    achievementsStrategyMounted()
  }, [])

  const handleChange = (event: any) => {
    setAchievement(event.currentTarget.value)
  }

  const handleSubmit = () => {
    submitAchievementStrategy({
      achievementId: achievement,
      strategyId: strategy.id,
    })
    onCancel()
  }

  return (
    <CModal
      visible={isOpen}
      onClose={() => {
        onCancel()
      }}
    >
      <CModalHeader>Add achievement</CModalHeader>
      <CModalBody>
        <CForm>
          <CRow className="mb-3">
            <CFormSelect
              label="Achievement"
              name="achievement"
              value={
                achievementsStrategy.find((item) => item.id === achievement)
                  ?.title
              }
              onChange={handleChange}
            >
              <option>Choose achievement</option>
              {achievementsStrategy.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.title}
                </option>
              ))}
            </CFormSelect>
          </CRow>
        </CForm>
      </CModalBody>
      <CModalFooter>
        <CButton
          color="secondary"
          onClick={() => {
            onCancel()
          }}
        >
          Cancel
        </CButton>
        <CButton color="primary" className="px-4" onClick={handleSubmit}>
          Add
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
